/**
 * 到着時刻と出発時刻の差分を「x日y時間z分」形式の滞在時間文字列へ変換する。
 * @param arrivedAt 到着時刻
 * @param departedAt 出発時刻
 * @returns 滞在時間文字列。時刻不正または差分0以下の場合は空文字
 */
export const formatShipmentStayDuration = (
  arrivedAt: string,
  departedAt: string,
): string => {
  const arrivedAtDate = new Date(arrivedAt);
  const departedAtDate = new Date(departedAt);
  const diffMs = departedAtDate.getTime() - arrivedAtDate.getTime();

  if (
    Number.isNaN(arrivedAtDate.getTime()) ||
    Number.isNaN(departedAtDate.getTime()) ||
    diffMs <= 0
  ) {
    return '';
  }

  const totalMinutes = Math.floor(diffMs / (1000 * 60));
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  const durationParts: string[] = [];
  if (days > 0) {
    durationParts.push(`${days}日`);
  }
  if (hours > 0 || days > 0) {
    durationParts.push(`${hours}時間`);
  }
  durationParts.push(`${minutes}分`);

  return durationParts.join('');
};
